var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Ilha de Hong Kong",
	Kowloon: Kowloon,
	"Lantau Island": "Ilha de Lantau",
	"New Territories": "Novos Territórios"
};

export { Kowloon, HKStates as default };
